import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=e5264a8e&scoped=true&"
import script from "./NewHome.vue?vue&type=script&lang=js&"
export * from "./NewHome.vue?vue&type=script&lang=js&"
import style0 from "./NewHome.vue?vue&type=style&index=0&id=e5264a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5264a8e",
  null
  
)

export default component.exports